<template>
  <div class="header">
    <slot/>
  </div>
</template>

<script>
export default {
  name: "PageHeader",
  data() {
    return {
      fromModule: null,
    }
  },
  props: {
    showBack: {
      type: Boolean,
      default: false
    }
  },
  methods: {},
  mounted() {
  }
}
</script>

<style scoped>
.header {
  background-color: #ffffff;
  padding: 10px 10px;
  margin-bottom: 10px;
  border-style: solid;
  border-width: 1px;
  border-color: #eeeeee;
  display: flex;
  min-height: 32px;
  line-height: 32px;
}
</style>
